export const HORIZONTAL_MENU_METADATA = {
  displayNames: {
    menu: 'HorizontalMenu',
    item: 'HorizontalMenuItem',
    flyout: 'HorizontalMenuFlyout',
    columns: 'HorizontalMenuColumns',
    scrollButton: 'HorizontalMenuScrollButton',
  },
};
